import { useState, useEffect, useMemo } from 'react';
import { UrlApi } from '../../../../services/apirest';
import { Box, Divider, Card, CardHeader, CardContent, Stack, Chip, Tooltip, Typography, IconButton, Container, Button, Grid } from '@mui/material';
import { Download, Visibility, Description } from "@mui/icons-material";
import { DownloadFiles } from '../../../../services/DownloadFiles';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import UploadFiles from '../../../compras/UploadFiles';
import moment from 'moment/moment';
import MaterialReactTable from "material-react-table";
import { logDOM } from '@testing-library/react';

export default function DocumentacionCli(props) {
    const [archivos, setArchivos] = useState([]);
    const [reclamos, setReclamos] = useState();
    const [direcciones, setdirecciones] = useState();
    const [documentacionTecnica, setdocumentacionTecnica] = useState([]);
    const [openclose, setopenclose] = useState(false);
    const [imageUrl, setImageUrl] = useState("");

    const getReclamos = () => {
        fetch(UrlApi + "/reclamos/cliente/" + props.cliente.id)
            .then((data) => data.json())
            .then((data) => setReclamos(data));
    };

    const getDirecciones = () => {
        fetch(`${UrlApi}/direccionesentrega/cli/${props.cliente?.id}`)
            .then((res) => res.json())
            .then(data => setdirecciones(data))
    };

    useEffect(() => {
        getReclamos()
        getDirecciones()
    }, []);


    useEffect(() => {
        if (!direcciones && !props.cliente?.id) return;

        //limpio antes de cargar nuevos resultados
        setdocumentacionTecnica([]);

        //busco adjuntos por direccion de entrega 
        if (direcciones) {
            direcciones.forEach((d) => {
                fetch(`${UrlApi}/uploadfiles/todownload/${d.nro_dir}`)
                    .then((res) => res.json())
                    .then((data) => {
                        setdocumentacionTecnica((prev) => [...prev, ...data]);
                    })
                console.log("URL", `${UrlApi}/uploadfiles/todownload/${d.nro_dir}`);
            })
        }

        console.log("direcciones", direcciones);

        // // Buscar también por cliente
        if (props.cliente?.id) {
            fetch(`${UrlApi}/uploadfiles/todownload/${props.cliente?.id}`)
                .then((res) => res.json())
                .then((data) => {
                    setdocumentacionTecnica((prev) => [...prev, ...data]);
                })
                .catch((err) => console.error(err));
        }
    }, [direcciones, openclose])

    useEffect(() => {
        if (!reclamos && !props.cliente?.id) return;

        // Limpio antes de cargar nuevos resultados
        setArchivos([]);

        // Buscar por cada reclamo
        if (reclamos) {
            reclamos.forEach((r) => {
                fetch(`${UrlApi}/uploadfiles/todownload/${r.uuid}`)
                    .then((res) => res.json())
                    .then((data) => {
                        setArchivos((prev) => [...prev, ...data]);
                    })
                    .catch((err) => console.error(err));
            });
        }
    }, [reclamos]);

    useEffect(() => {
        if (imageUrl) {
            window.open(imageUrl, "_blank", "noreferrer");
            setImageUrl(null); // para que no abra nuevamente con re-render
        }
    }, [imageUrl]);

    const fetchPdf = async (archivo) => {
        const response = await fetch(UrlApi + "/uploadfiles/uploadspdf/" + archivo);
        setImageUrl(URL.createObjectURL(await response.blob()));
    };

    const fetchImage = async (archivo) => {
        const response = await fetch(UrlApi + "/uploadfiles/uploads/" + archivo);
        setImageUrl(URL.createObjectURL(await response.blob()));
    };

    const ViewFiles = async (archivo, extension) => {
        (await extension) === "application/pdf"
            ? fetchPdf(archivo)
            : fetchImage(archivo);
    };

    const archivosPorReclamo = Array.isArray(reclamos)
        ? reclamos
            .map((r) => ({
                ...r,
                archivos: Array.isArray(archivos)
                    ? archivos.filter((a) => a.id_archivo === r.uuid)
                    : [],
            }))
            .filter((r) => r.archivos.length > 0) // 👈 solo los reclamos con archivos
        : [];

    const columns = useMemo(
        () => [
            {
                header: "#",
                accessorKey: "id_reclamo",
            },
            {
                header: "Detalle",
                accessorKey: "detalle",
            },
            {
                header: "Fecha",
                accessorKey: "created_at",
                Cell: ({ cell }) =>
                    cell.getValue()
                        ? new Date(cell.getValue()).toLocaleString("es-AR")
                        : "-",
            },
            {
                header: "Archivos",
                accessorFn: (row) => row.archivos?.length || 0,
                size: 50,
            },
        ],
        []
    );

    const displayColumnDefOptions = {
        "mrt-row-actions": {
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 14,
                    color: "black",
                    fontWeight: "normal",
                    paddingTop: 1,
                    paddingBottom: 1,
                    backgroundColor: " #D4E6F1",
                    borderColor: "#FDFEFE",
                },
            },
            size: 60,
        },
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: {
            pageSize: 5,
            pageIndex: 0,
        },
    };

    const tableHeadCellProps = {
        align: "left",
        sx: {
            fontSize: 14,
            color: "black",
            fontWeight: "normal",
            backgroundColor: " #D4E6F1",
            borderColor: "#FDFEFE",
        },
    };

    const reclamosConArchivos =
        archivosPorReclamo?.filter((r) => r.archivos && r.archivos.length > 0) || [];


    return (
        <Container mb={10} maxWidth="xl" disableGutters>
            <MaterialReactTable
                columns={columns}
                data={reclamosConArchivos}
                enablePagination
                enableExpanding
                enableBottomToolbar
                enableTopToolbar={false}
                paginationDisplayMode="pages"
                initialState={initialState}
                displayColumnDefOptions={displayColumnDefOptions}
                muiTableHeadCellProps={tableHeadCellProps}
                renderDetailPanel={({ row }) => {
                    const r = row.original;
                    return (
                        <Card
                            variant="outlined"
                            sx={{
                                mt: 2,
                                mb: 2,
                                borderRadius: 3,
                                boxShadow: 2,
                                backgroundColor: "#fafafa",
                            }}
                        >
                            {/* <CardHeader
                                title={`Reclamo #${r.id_reclamo}`}
                                subheader={moment(r.created_at).format("DD/MM/YYYY HH:mm:ss")}
                                sx={{
                                    backgroundColor: "#1976d2",
                                    color: "white",
                                    borderTopLeftRadius: 12,
                                    borderTopRightRadius: 12,
                                    "& .MuiCardHeader-title": {
                                        fontSize: "1rem", 
                                        lineHeight: 1.2,
                                    },
                                    "& .MuiCardHeader-subheader": {
                                        fontSize: "0.8rem", 
                                        lineHeight: 1,
                                        color: "rgba(255,255,255,0.8)",
                                    },
                                    padding: "8px 16px", 
                                }}
                            /> */}
                            <CardContent>
                                {/* <Typography variant="subtitle1" gutterBottom>
                                    {r.detalle}
                                </Typography> */}

                                {/* <Divider sx={{ mb: 2 }} /> */}

                                {r.archivos.length > 0 ? (
                                    <Stack spacing={1}>
                                        {r.archivos.map((a) => (
                                            <Box
                                                key={a.id_archivo}
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                sx={{
                                                    p: 1.5,
                                                    borderRadius: 2,
                                                    backgroundColor: "#f1f5f9",
                                                    "&:hover": { backgroundColor: "#e3f2fd" },
                                                }}
                                            >
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <Description color="primary" />
                                                    <Typography>{a.nombre} {a.usuario}</Typography>
                                                    <Chip
                                                        label={a.extension.split("/")[1]?.toUpperCase()}
                                                        size="small"
                                                        color="primary"
                                                        variant="outlined"
                                                    />
                                                </Box>

                                                <Box>
                                                    <Tooltip title="Ver archivo">
                                                        <IconButton
                                                            color="info"
                                                            onClick={() => ViewFiles(a.id_archivo + "-" + a.nombre, a.extension)}
                                                            disabled={
                                                                !(
                                                                    a.extension === "application/pdf" ||
                                                                    a.extension === "image/jpeg"
                                                                )
                                                            }
                                                        >
                                                            <Visibility />
                                                        </IconButton>
                                                    </Tooltip>

                                                    <Tooltip title="Descargar">
                                                        <IconButton
                                                            color="success"
                                                            onClick={() => DownloadFiles(a.id_archivo + "-" + a.nombre)}
                                                        >
                                                            <Download />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Stack>
                                ) : (
                                    <Typography color="text.secondary">Sin archivos adjuntos.</Typography>
                                )}
                            </CardContent>
                        </Card>
                    );
                }}
            />

            <Divider sx={{ mb: 2 }} />
            <Box>
                <Grid
                    container
                    direction="row"
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="button" gutterBottom>
                        DOCUMENTACIÓN técnica
                    </Typography>
                    <Button
                        onClick={() => setopenclose(!openclose)}
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<AttachFileIcon />}
                        sx={{ mb: 2 }}
                    >
                        Cargar archivos nuevos
                    </Button>
                </Grid>
                {documentacionTecnica.length > 0 ? (
                    <Stack spacing={1}>
                        {documentacionTecnica.map((a) => (
                            <Box
                                key={a.id_archivo}
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{
                                    p: 1.5,
                                    borderRadius: 2,
                                    backgroundColor: "#f1f5f9",
                                    "&:hover": { backgroundColor: "#e3f2fd" },
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Description color="primary" />
                                    <Typography>{a.nombre} {a.usuario}</Typography>
                                    <Chip
                                        label={a.extension.split("/")[1]?.toUpperCase()}
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                    />
                                </Box>

                                <Box>
                                    <Tooltip title="Ver archivo">
                                        <IconButton
                                            color="info"
                                            onClick={() => ViewFiles(a.id_archivo + "-" + a.nombre, a.extension)}
                                            disabled={
                                                !(
                                                    a.extension === "application/pdf" ||
                                                    a.extension === "image/jpeg"
                                                )
                                            }
                                        >
                                            <Visibility />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Descargar">
                                        <IconButton
                                            color="success"
                                            onClick={() => DownloadFiles(a.id_archivo + "-" + a.nombre)}
                                        >
                                            <Download />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        ))}
                    </Stack>
                ) : (
                    <Typography color="text.secondary">Sin archivos adjuntos.</Typography>
                )}

                {/* Modal de subida de archivos */}
                {openclose && (
                    <UploadFiles
                        fileId={props.cliente.id}
                        open={openclose}
                        setOpen={setopenclose}
                        title={"Adjuntar archivos"}
                    />
                )}

            </Box>
        </Container>
    );
}


//     return (
//         <Container mb={10} maxWidth="xl" disableGutters>
//             {/* Botón para cargar nuevos archivos */}
//             <Button
//                 onClick={() => setopenclose(!openclose)}
//                 variant="outlined"
//                 color="primary"
//                 size="small"
//                 startIcon={<AttachFileIcon />}
//                 sx={{ mb: 2 }}
//             >
//                 Cargar archivos nuevos
//             </Button>

//             {archivosPorReclamo.length > 0 ? (
//                 archivosPorReclamo
//                     .filter((r) => r.archivos && r.archivos.length > 0) // solo los que tienen archivos
//                     .map((r) => (
//                         <Accordion key={r.uuid} sx={{ mb: 2 }}>
//                             <AccordionSummary
//                                 expandIcon={<ExpandMoreIcon />}
//                                 aria-controls={`panel-${r.uuid}-content`}
//                                 id={`panel-${r.uuid}-header`}
//                             >
//                                 <Typography variant="subtitle1" fontWeight="bold">
//                                     🧾 Reclamo {r.id_reclamo} — {r.detalle}
//                                 </Typography>
//                             </AccordionSummary>

//                             <AccordionDetails>
//                                 {r.archivos && r.archivos.length > 0 ? (
//                                     <TableContainer component={Paper}>
//                                         <Table>
//                                             <TableHead>
//                                                 <TableRow>
//                                                     <TableCell>
//                                                         <Typography variant="button">Archivos adjuntos</Typography>
//                                                     </TableCell>
//                                                     <TableCell align="center">Acciones</TableCell>
//                                                 </TableRow>
//                                             </TableHead>
//                                             <TableBody>
//                                                 {r.archivos.map((a) => (
//                                                     <TableRow key={a.id}>
//                                                         <TableCell>{a.nombre}</TableCell>
//                                                         <TableCell align="center">
//                                                             <IconButton
//                                                                 size="small"
//                                                                 color="secondary"
//                                                                 onClick={() =>
//                                                                     ViewFiles(a.id_archivo + "-" + a.nombre, a.extension)
//                                                                 }
//                                                                 disabled={
//                                                                     !(
//                                                                         a.extension === "application/pdf" ||
//                                                                         a.extension === "image/jpeg"
//                                                                     )
//                                                                 }
//                                                             >
//                                                                 <VisibilityIcon />
//                                                             </IconButton>

//                                                             <IconButton
//                                                                 size="small"
//                                                                 color="success"
//                                                                 onClick={() =>
//                                                                     DownloadFiles(a.id_archivo + "-" + a.nombre)
//                                                                 }
//                                                             >
//                                                                 <DownloadForOfflineIcon />
//                                                             </IconButton>
//                                                         </TableCell>
//                                                     </TableRow>
//                                                 ))}
//                                             </TableBody>
//                                         </Table>
//                                     </TableContainer>
//                                 ) : (
//                                     <Typography variant="body2" color="text.secondary">
//                                         No hay archivos adjuntos para este reclamo.
//                                     </Typography>
//                                 )}
//                                 <Divider sx={{ mt: 2 }} />
//                             </AccordionDetails>
//                         </Accordion>
//                     ))
//             ) : (
//                 <Typography variant="body2" color="text.secondary">
//                     No hay reclamos registrados para este cliente.
//                 </Typography>
//             )}

//             {/* Modal de subida de archivos */}
//             {openclose && (
//                 <UploadFiles
//                     fileId={props.cliente.id}
//                     open={openclose}
//                     setOpen={setopenclose}
//                     title={"Adjuntar archivos"}
//                 />
//             )}
//         </Container>
//     );
// }